<script setup lang="ts">

useHead({
  meta: [
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
  ],
  link: [
    { rel: 'icon', type: 'image/png', href: '/favicon.png'}
  ],
  htmlAttrs: {
    lang: 'fr'
  }
})

useSeoMeta({
  titleTemplate: (title) => title ? `${title} - Espace Asso by Benevolt` : 'Espace Asso by Benevolt - L’engagement se transforme. Et vous ?',
  ogSiteName: 'Espace Asso by Benevolt',
  ogType: 'website',
  ogImage: 'https://asso.benevolt.fr/opengraph.jpg',
  twitterCard: 'summary_large_image',
  twitterSite: 'benevolt_fr',
})

if (useRoute().query.utm_source || useRoute().query.utm_campaign) {
  const utmSource = useCookie('espaceasso_utm_source', {maxAge: 60 * 60 * 24, domain: useDomain()})
  const utmCampaign = useCookie('espaceasso_utm_campaign', {maxAge: 60 * 60 * 24, domain: useDomain()})
  utmSource.value = useRoute().query.utm_source
  utmCampaign.value = useRoute().query.utm_campaign
}
</script>

<template>
  <Header />
  <UMain>
    <slot />
  </UMain>
  <Footer />
</template>